import { styled } from "@styles";
import { Accordion, Card } from "react-bootstrap";

export const Wrapper = styled(Accordion)``;

export const CheckoutOrderNoteCard = styled(Card)``;

export const CheckoutOrderNoteCardHeader = styled(Card.Header)`
  text-align: center;
`;

export const CheckoutOrderNoteCardHeaderTitle = styled(Accordion.Toggle)`
  text-transform: uppercase;
  font-weight: 700;
`;

export const CheckoutOrderNoteCardCollapse = styled(Accordion.Collapse)``;

export const CheckoutOrderNoteCardBody = styled(Card.Body)``;